var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('style',[_vm._v("\n/* This style tag is for scripting purposes (see getComputedStyle, below) */\nhead::before {\n    content:\"desktop\";\n}\n@media (pointer:coarse) {\n    /*@media (pointer:coarse) {*/\n    head::before {\n        content:\"mobile\";\n    }\n}\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3598a484","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/startups/Welcome.vue
// module id = KQo6
// module chunks = 1